/* ───────────────── AttachmentBox: 첨부파일 리스트/미리보기/삭제 ───────────────── */
import React from "react";

function AttachmentBox({
    files = [],
    onChange,
    accept = "*/*",
    maxFiles = 20,
    }) {
    // 선택
    const onPick = (e) => {
        const picked = Array.from(e.target.files || []);
        if (!picked.length) return;

        const remain = Math.max(0, maxFiles - (files?.length || 0));
        const slice = picked.slice(0, remain);

        const mapped = slice.map((f) => ({
        id: Date.now() + Math.random(),
        name: f.name,
        size: f.size,
        type: f.type,
        url: URL.createObjectURL(f), // 객체 URL
        __objectUrl: true,           // 해제용 플래그
        file: f,
        }));
        onChange && onChange([...(files || []), ...mapped]);
        e.target.value = "";
    };

    // 삭제(+ 객체 URL 해제)
    const remove = (id) => {
        const target = (files || []).find((f) => f.id === id);
        if (target?.__objectUrl && target.url) {
        try { URL.revokeObjectURL(target.url); } catch {}
        }
        const rest = (files || []).filter((f) => f.id !== id);
        onChange && onChange(rest);
    };

    // 언마운트 시 객체 URL 정리
    React.useEffect(() => {
        return () => {
        (files || []).forEach((f) => {
            if (f.__objectUrl && f.url) {
            try { URL.revokeObjectURL(f.url); } catch {}
            }
        });
        };
    }, [files]);

    return (
        <div className="attach-wrap">
        <div className="d-flex gap-2 mb-2">
            <label className="btn btn-sm btn-outline-secondary mb-0">
            <i className="fa-solid fa-paperclip me-1" /> 첨부파일 추가
            <input type="file" hidden multiple accept={accept} onChange={onPick} />
            </label>
            <div className="text-muted small d-flex align-items-center">
            총 {files?.length || 0}개 / 최대 {maxFiles}개
            </div>
        </div>

        {!!(files?.length) && (
            <div className="row g-2">
            {files.map((f) => (
                <div className="col-md-6" key={f.id}>
                <div className="border rounded p-2 d-flex align-items-center gap-2">
                    {/^image\//.test(f.type || "") || /\.(png|jpe?g|gif|webp|svg)$/i.test(f.name || "") ? (
                    <img
                        src={f.url}
                        alt={f.name}
                        style={{ width: 56, height: 40, objectFit: "cover", borderRadius: 6 }}
                    />
                    ) : (
                    <div className="text-center" style={{ width: 56 }}>
                        <i className="fa-regular fa-file-lines fa-lg" />
                    </div>
                    )}

                    <div className="flex-fill">
                    <div className="small fw-semibold text-truncate">{f.name}</div>
                    {typeof f.size === "number" && (
                        <div className="text-muted small">{(f.size / 1024).toFixed(1)} KB</div>
                    )}
                    </div>

                    <div className="d-flex gap-2">
                    <a
                        className="btn btn-sm btn-outline-secondary"
                        href={f.url}
                        download={f.name}
                        title="다운로드"
                    >
                        <i className="fa-solid fa-download" />
                    </a>
                    <button className="btn btn-sm btn-outline-danger" onClick={() => remove(f.id)}>
                        <i className="fa-regular fa-trash-can" />
                    </button>
                    </div>
                </div>
                </div>
            ))}
            </div>
        )}
        </div>
    );
}

export { AttachmentBox };     // named export도 유지
export default AttachmentBox;  // ✅ default export 추가
